import $ from 'jquery';
import ko from 'knockout';
import { parseClientModel } from '../../util/parse';
import { ReportForm } from '../report/ReportForm';
import { ContextForm, ContextListForm, Form, ListForm, ObjectForm, ParameterForm } from './model';
import { settings } from '../../areas/main/config';

export function bindForm(container?: Element | JQuery): ObjectForm | undefined {
	var element = selectFormElement(container);
	let objectForm: ObjectForm | undefined;

	element.each((_, e) => {
		var data: any = parseClientModel($('#form-model', e)) || {};
		var formType = $(e).attr('data-form-type');
		var form: Form;

		switch (formType) {
			case 'list':
				form = new ListForm(data);
				break;

			case 'context':
				form = new ContextForm(data);
				break;

			case 'context-list':
				form = new ContextListForm(data);
				break;

			case 'report':
				form = new ReportForm(data.parameters, data.items)
				break;

			case 'parameter-form':
				form = new ParameterForm(data);
				break;

			default:
				const currentForm = new ObjectForm(data);
				form = objectForm = currentForm;
				let submitHandler: number | undefined;

				const jForm = $(e);
				jForm.on('keydown', (event) => {
					if (submitHandler) {
						return;
					}

					if (event.which !== 13) {
						return;
					}

					if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) {
						return;
					}

					const target = event.target as HTMLElement;
					if (target) {
						const tagName = target.tagName.toLowerCase();
						const isContentEditable =
							target.isContentEditable
							|| target.closest('[contenteditable="true"], [contenteditable=""]') !== null;

						if (tagName === "textarea" || isContentEditable || isClickable(target)) {
							return;
						}
					}

					const submitButtons = jForm.find('button[type="submit"], button:not([type])');
					if (submitButtons.length) {
						//override the default form submit behaviour to ensure that any pending updates are applied before submitting
						event.preventDefault();
						flushFocusedField(target);

						//allow for any pending	select2 search requests to begin
						submitHandler = setTimeout(() => {
							//wait for any pending search requests to complete
							whenBrowserRequestsIdle(() => {
								//wait for form updates to apply
								currentForm?.whenIdle(() => {
									try {
										const button = submitButtons.filter(":visible:not([disabled])").first();
										if (button.length) {
											button.trigger("click");
										}
									}
									finally {
										submitHandler = undefined;
									}
								});
							});
						}, settings.inputSearchDelay);
					}
				});
		}

		Form.root = form;
		ko.applyBindings(form, e);
	});

	$('.tip', container).tooltip();

	return objectForm;
}

export function unbindForm(container?: Element | JQuery) {
	var element = selectFormElement(container);
	element.each((i, e) => {
		ko.cleanNode(e);
	});
}

export function findForm(container?: Element | JQuery) {
	var element = selectFormElement(container);
	if (!element || !element.length) {
		return null;
	}

	var form = ko.dataFor(element[0]);
	if (form instanceof Form) {
		return form;
	}
	else {
		return null;
	}
}

function selectFormElement(container?: Element | JQuery): JQuery {
	return $('form.form-model', container)
}

function isClickable(element: HTMLElement): boolean {
	if (element.matches('input[type="text"]')) {
		return false;
	}

	return element.closest(
		'a[href], button, [role="button"], [role="link"], summary, label, input[type="button"], input[type="submit"], input[type="reset"], input[type="checkbox"], input[type="radio"], input[type="file"]'
	) !== null;
}

function flushFocusedField(target: HTMLElement) {
	const isFormField = target.matches('input, textarea, select') || target.closest('[contenteditable="true"], [contenteditable=""]') !== null;

	if (isFormField) {
		target.blur();
	}
}

function whenBrowserRequestsIdle(callback: () => void) {
	const jQueryWithActive = $ as JQueryStatic & { active?: number };

	const onAjaxStop = () => {
		$(document).off('ajaxStop', onAjaxStop);
		callback();
	};

	$(document).one('ajaxStop', onAjaxStop);

	if ((jQueryWithActive.active ?? 0) <= 0) {
		onAjaxStop();
	}
	else {
		console.log('Form will submit after', jQueryWithActive.active, 'active requests complete');
	}
}
